import { useEffect } from "react";

import { useRouter } from "@lib/router";

import { OrderFields } from "../../constants";
import getIsDeliveryDomestic from "../../utils/getIsDeliveryDomestic";
import useOrderFormik from "../useOrderFormik";

const useUpdateIsDomestic = (): void => {
  const {
    values: { [OrderFields.STARTING_COUNTRY]: countryFrom, [OrderFields.DESTINATION_COUNTRY]: countryTo },
    setFieldValue,
  } = useOrderFormik();

  const { defaultLocale } = useRouter();

  useEffect(() => {
    const isDomestic = getIsDeliveryDomestic(defaultLocale!, countryFrom!, countryTo!);
    setFieldValue(OrderFields.IS_DOMESTIC, isDomestic);
  }, [countryFrom, countryTo, defaultLocale, setFieldValue]);
};
export default useUpdateIsDomestic;
